"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._RefObjectFinder = exports._RemoveAllReferenceClones = void 0;
var helper_const_1 = require("./helper.const");
var cash_dom_1 = __importDefault(require("cash-dom"));
/**
 * Removes all clones from your reference objects
 * @param refObjects
 */
var _RemoveAllReferenceClones = function (refObjects) {
    for (var key in refObjects) {
        refObjects[key].removeClones();
    }
};
exports._RemoveAllReferenceClones = _RemoveAllReferenceClones;
/**
 * Finds data-ref objects inside a module and links saves it into your refObject
 * @param module data-module where should be searched in
 * @param refObjects that you want to get the elements from
 */
var _RefObjectFinder = function (module, refObjects) {
    var refContainer = (0, cash_dom_1.default)(module);
    var _loop_1 = function (key) {
        var refObject = refObjects[key];
        var domElement = refContainer.find("[data-ref=\"".concat(refObject.uid, "\"]")).not('[data-module]');
        // NOTE: OLD LEGACY MAYBE GETTING TOSSED NOT ENOUGH VALUE
        if (domElement.length === 0 &&
            (refObject === null || refObject === void 0 ? void 0 : refObject.legacy) &&
            (0, cash_dom_1.default)('#' + refObject.legacy).length) {
            domElement = refContainer.find('#' + refObject.legacy);
        }
        if (domElement.length) {
            console.log('found ref object', key);
            if (!refObject.keepRefTag) {
                domElement.removeAttr('data-ref');
            }
            refObject.parent = domElement.parent();
            if (!refObject.dontRemoveFromDom) {
                refObject.domElement = domElement.clone();
                domElement.remove();
            }
            else {
                refObject.domElement = domElement;
            }
        }
        else if (refObject === null || refObject === void 0 ? void 0 : refObject.required) {
            console.error('Module requires dom reference: ' + "[data-ref=\"".concat(refObject.uid, "\"]"));
        }
        /**
         * add helper functions they do nothing but are always defined
         */
        refObject.removeClones = function () {
            var _a, _b;
            if ((_b = (_a = refObjects[key]) === null || _a === void 0 ? void 0 : _a.domElement) === null || _b === void 0 ? void 0 : _b.length) {
                refContainer
                    .find("[data-clone=\"true\"][data-clone-id=\"".concat(refObjects[key].uid, "\"]"))
                    .remove();
            }
        };
        refObject.cloneDomElement = function (attributes, webflowSupport) {
            var _a, _b;
            if ((_b = (_a = refObjects[key]) === null || _a === void 0 ? void 0 : _a.domElement) === null || _b === void 0 ? void 0 : _b.length) {
                return _CreateRefObjectClones(refObjects[key].domElement, refObjects[key], attributes, webflowSupport);
            }
        };
    };
    for (var key in refObjects) {
        _loop_1(key);
    }
};
exports._RefObjectFinder = _RefObjectFinder;
/**
 * Clones a dom object
 * @param container
 * @param attributes
 * @param webflowSupport
 * @returns
 */
var _CreateRefObjectClones = function (container, refObject, attributes, webflowSupport) {
    if (attributes === void 0) { attributes = []; }
    if (container.length > 0) {
        var copiedObject_1 = container.clone();
        for (var _i = 0, attributes_1 = attributes; _i < attributes_1.length; _i++) {
            var attribute = attributes_1[_i];
            copiedObject_1.attr(attribute.key, attribute.value);
        }
        copiedObject_1.attr('data-clone', 'true');
        copiedObject_1.attr('data-clone-id', refObject === null || refObject === void 0 ? void 0 : refObject.uid);
        //NOTE: I REMOVED THAT SINCE IM THINKING ITS LEGACY BUT KEPT IT JUST IN CASE. SINCE WE DONT HIDE ORGIGNAL ELEMENTS ANYMORE AND INSTEAD REMOVE THEM I THINK THERE IS NO NEED FOR THIS
        // container.get()[0].style.cssText += 'display: none !important';
        // copiedObject.css({ display: '' });
        // // copiedObject.css('display', 'flex');
        copiedObject_1.removeAttr('id');
        copiedObject_1.removeAttr('data-ref');
        if (webflowSupport === true) {
            copiedObject_1.find('.w-dropdown-toggle').on('click', function () {
                copiedObject_1.find('.w-dropdown-toggle').toggleClass('w--open');
                copiedObject_1.find('.w-dropdown-list').toggleClass('w--open');
            });
        }
        (0, helper_const_1._CollapseAndUncollapse)(copiedObject_1);
        return copiedObject_1;
    }
};
